type BBLink = {
  href: string;
};

declare global {
  namespace BB {
    type Link = BBLink;
  }
}

export type Link = BBLink;
